export default __webpack_public_path__ + "static/media/c-tkp.9b95d09f.jpg";